export default {
    state: {
        currentUserId: '',
        currentRoleCode:'',
        currentRoleName:'',
        userAuthorityInfoList:[],
        currentUserIcon:'',
        isChildAdmin:true,
    },
    mutations: {
        setCurrentUserId(state, val) {
            state.currentUserId = val;
        },
        setUserAuthorityInfoList(state, val) {
            state.userAuthorityInfoList = val;
        },
        setCurrentRole(state, val) {
            state.currentRoleCode = val;
        },
        setCurrentRoleName(state, val) {
            state.currentRoleName = val;
        },
        setCurrentUserIcon(state, val) {
            state.currentUserIcon = val;
        },
        setIsChildAdmin(state, val) {
            state.isChildAdmin = val;
        }
    },
    actions: {}
}
